import styled from 'styled-components';

import { Row } from 'thesis-ui';

export const Container = styled(Row)`
  height: 100%;
`;
